import { get } from "lodash";
import moment from "moment";
import { all, fork, put, select, takeLatest } from "redux-saga/effects";
import { openToast } from "~/components/common/molecules/ToastNotification";
import history from "~/history";
import patientType from "~/store/patient/patientType";
import * as types from "~/store/patientForm/patientFormType";
import { client } from "~/utils/medproSDK";
import { handleUnAuthorize } from "~/utils/unAuthorize";
import { logOutWithoutNoti } from "../user/userAction";

function* requestCreatePatientInForm({ force }) {
  try {
    const { info: patientInfo } = yield select(state => state.patientForm);
    const { urlRedirectAfterCreatePatient } = yield select(
      state => state.patientForm
    );
    const partnerid = yield select(state => state.totalData.partnerId);

    const keys = Object.keys(patientInfo);
    const postData = {};
    keys.map(key => {
      postData[key] = patientInfo[key].value;
      return "";
    });

    const getFullname = postData.fullname.split(" ");
    postData.surname = getFullname.slice(0, -1).join(" ");
    postData.name = getFullname.slice(-1).join(" ");

    postData.birthdate = moment(
      `${postData.birthyear}-${postData.birthmonth}-${postData.birthday}`,
      "YYYY-MM-DD"
    )
      .utc(true)
      .toISOString();

    postData.force = force;

    const yearOld = moment().diff(postData.birthdate, "years", true);

    if (yearOld < 18) {
      postData.mobile = postData.relative_mobile;
    }

    if (!postData.mobile) {
      postData.mobile = postData.relative_mobile;
    }

    delete postData.birthmonth;
    delete postData.birthday;

    const token = yield select(state => state.user.info.token);

    const response = yield client.insertPatient(
      { ...postData },
      {
        partnerid: partnerid || "medpro",
        token,
        platform: "pc"
      }
    );

    const { data } = response;
    if (data.isRecommended) {
      yield put({
        type: types.CHECK_PATIENT_BEFORE_CREATE,
        newPatient: data.patientForm,
        listOldPatient: data.recommendedPatientList
      });
      openToast(data.message, "error");
      history.push("/check-patient-before-create");
    } else {
      if (typeof data.error_code === typeof undefined) {
        yield put({
          type: patientType.SELECTED_PATIENT_AFTER_CREATE,
          selectedPatient: data
        });
        yield put({
          type: types.CREATE_PATIENT_FORM_SUCCESS,
          info: data
        });
        openToast("Tạo mới hồ sơ thành công.");
      }
      history.push(urlRedirectAfterCreatePatient);
    }
  } catch (error) {
    console.log(error);
    const errorCMND = get(
      error,
      "response.data.message[0].constraints.isNumberString",
      false
    );
    const errMobile = get(
      error,
      "response.data.message[0].constraints.isMobilePhone",
      false
    );
    const errorCMND2 = get(
      error,
      "response.data.message[0].constraints.CheckCMND",
      false
    );
    const trungHoSo = get(error, "response.data.message", false);
    if (error.response.data.statusCode === 400) {
      if (errMobile) openToast(errMobile, "error");
      if (errorCMND) openToast(errorCMND, "error");
      if (errorCMND2) openToast(errorCMND2, "error");
    }
    if (error.response.data.statusCode === 401) {
      yield put(logOutWithoutNoti());
      handleUnAuthorize();
    }
    if (error.response.data.statusCode === 409) {
      if (trungHoSo) openToast(trungHoSo, "error");
    }
    yield put({
      type: types.CREATE_PATIENT_FORM_FAILURE,
      error
    });
  }
}

function* watchRequestCreatePatientForm() {
  yield takeLatest(
    types.CREATE_PATIENT_FORM_REQUEST,
    requestCreatePatientInForm
  );
}

function* getPatientDetailWorker({ id }) {
  try {
    const token = yield select(state => state.user.info.token);
    const response = yield client.getPatientInfoToUpdate({ id }, { token });

    if (response.status !== 200) throw new Error("Server error");
    yield put({
      type: types.DETAIL_PATIENT_FORM_SUCCESS,
      info: {
        ...response.data
      }
    });
    yield put({
      type: patientType.SELECTED_PATIENT_DETAIL,
      value: response.data
    });
  } catch (error) {
    yield put({
      type: types.DETAIL_PATIENT_FORM_FAILURE,
      error
    });
  }
}

function* updatePatientlWorker() {
  try {
    const { info: patientInfo } = yield select(state => state.patientForm);
    const { phoneNumberVerify } = yield select(state => state.patient);
    const isUpdateFull = get(patientInfo, "isUpdateFull.value");
    const keys = Object.keys(patientInfo);

    const partnerid = yield select(state => state.totalData.partnerId);

    const postData = {};
    keys.map(key => {
      postData[key] = patientInfo[key].value;
      return "";
    });

    const getFullname = postData.fullname.split(" ");
    postData.surname = getFullname.slice(0, -1).join(" ");
    postData.name = getFullname.slice(-1).join(" ");
    postData.relative_name = postData.relative_name.toUpperCase();

    if (postData?.mobile?.includes("xx")) {
      postData.mobile = phoneNumberVerify;
    }

    const currentYear = Number(moment().format("YYYY"));
    const yearOld = currentYear - postData.birthyear;

    if (!postData.mobile && yearOld < 18) {
      postData.mobile = postData.relative_mobile;
    }

    postData.birthdate = moment(
      `${postData.birthyear}-${postData.birthmonth}-${postData.birthday}`,
      "YYYY-MM-DD"
    )
      .utc(true)
      .toISOString();

    const token = yield select(state => state.user.info.token);

    let response;
    if (isUpdateFull) {
      response = yield client.updatePatientWithoutPatientCode(postData, {
        partnerid,
        token
      });
    } else {
      response = yield client.updatePatientWithPatientCode(postData, {
        partnerid,
        token
      });
    }

    yield put({
      type: types.UPDATE_PATIENT_FORM_SUCCESS,
      info: response.data
    });

    openToast("Cập nhật thành công!");
    window.history.go(-1);
  } catch (error) {
    console.log("error 222:>> ", error);

    const statusCode = get(error, "response.data.statusCode", 0);
    const errorCMND = get(
      error,
      "response.data.message[0].constraints.isNumberString",
      false
    );
    const errorCMND2 = get(
      error,
      "response.data.message[0].constraints.CheckCMND",
      false
    );
    if (error.response.data.statusCode === 400) {
      if (errorCMND) openToast(errorCMND, "error");
      if (errorCMND2) openToast(errorCMND2, "error");
    }
    if (statusCode === 401) {
      localStorage.removeItem("jwt");
      yield put(logOutWithoutNoti());
    }
    yield put({
      type: types.UPDATE_PATIENT_FORM_FAILURE,
      error
    });
  }
}

function* watchPatient() {
  yield all([
    takeLatest(types.DETAIL_PATIENT_FORM_REQUEST, getPatientDetailWorker),
    takeLatest(types.UPDATE_PATIENT_FORM_REQUEST, updatePatientlWorker)
  ]);
}

export default function* root() {
  yield all([fork(watchRequestCreatePatientForm), fork(watchPatient)]);
}
